import splitStringWithParenthesisIntoTwoLinesStringUtil from 'utils/string/split-string-in-two-lines'

/**
 * @param sizeLabel
 * @returns {{firstLabel: *, sizeLabelArr: String[], size: string, enoughForLabel: *, firstLabelArr: *, enoughForLabelShort: *}|undefined}
 */
export default function getSizeGuideLabelDataProductUtil ({ sizeLabel }) {
  if (!sizeLabel) {
    return
  }

  const sizeLabelArr = splitStringWithParenthesisIntoTwoLinesStringUtil(sizeLabel)
  let firstLabel
  const firstSizeLabel = sizeLabelArr[0]
  // e.g.
  // 1) from -> 15 ml - enough for 3-4 uses
  // 2) from -> 1.5 ml - enough for 5+ uses (partially filled in a 3ml spritzer)
  if (
    firstSizeLabel.indexOf('-') > -1
  ) {
    // e.g.
    // 1) to -> 15 ml enough for 3-4 uses
    // 2) to -> 1.5 ml enough for 5+ uses (partially filled in a 3ml spritzer)
    const firstPart = firstSizeLabel.slice(0, firstSizeLabel.indexOf(' -'))
    const secondPart = firstSizeLabel.slice(firstSizeLabel.indexOf('-') + 1)
    firstLabel = `${firstPart}${secondPart}`
  } else {
    // e.g. 15ml
    firstLabel = firstSizeLabel
  }

  const firstLabelArr = firstLabel.replace('/', '').split(' ')
  const enoughForLabel = firstLabelArr.slice(2).join(' ')
  const enoughForLabelShort = enoughForLabel.replace(/enough for /gi, '').replace(/Eau de Parfum Spray/gi, '')
  const size = firstLabelArr[1] ? `${firstLabelArr[0]} ${firstLabelArr[1]}` : firstLabelArr[0]

  return {
    sizeLabelArr,
    firstLabel,
    firstLabelArr,
    enoughForLabel,
    enoughForLabelShort,
    size
  }
}
